export const ITEM_KEYS = {
  activeKey: 'status',
  selectedKey: 'uuid',
  titleKey: 'name',
}

export const QA_NAME_IDWELL_TO_IDWELL_SUB_MENU = 'idwellToIdwell'

export const IDWELL_TO_IDWELL_OUTBOUND_COMPANY_ACTIVE_STATUS = 'valid'

export const FILTER_NAME_OUTBOUND_UUID = 'outbound_uuid'
